import { SnackBar } from '@umu/umu-design';

export const dealCheckVal = (val: string) => {
    if (val === '') {
        return true;
    }
    const Expression = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;
    const objExp = new RegExp(Expression);
    return objExp.test(val);
};

export const showMsgToast = (message: string) => {
    SnackBar.show({
        message,
    })
};